import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

export default function Partnerships() {

const brands = [
    { name: "Red Sur Design", src: "/media/logos/redsurdesign.svg", url: "https://www.instagram.com/reel/DB7KfpfRtxf/" },
    { name: "3001 Deco", src: "/media/logos/3001deco.svg", url: "https://www.instagram.com/piso.05/reel/DM586p5xwAa/" },
    { name: "Arty", src: "/media/logos/arty.svg", url: "https://www.instagram.com/piso.05/reel/DNytgqu4mR2/" },
    { name: "Brutal", src: "/media/logos/brutal.svg", url: "https://www.instagram.com/brutaldsgn___/reel/DMbRHjRRgiR/" },
    { name: "Cuerda", src: "/media/logos/cuerda.svg", url: "https://www.instagram.com/piso.05/reel/DR25NJIkalT/" },
    { name: "Dual Concept Store", src: "/media/logos/dualconceptstore.svg", url: "https://www.instagram.com/piso.05/reel/DR0NFtpkbo4/" },
    { name: "SuHome", src: "/media/logos/suhome.svg", url: "https://www.instagram.com/piso.05/reel/DLVoxxWRmB0/" },
    { name: "Teneues", src: "/media/logos/teneues.svg", url: "https://www.instagram.com/piso.05/reel/DM0Ri71xP86/" },
    { name: "Konzept", src: "/media/logos/konzept.svg", url: "https://www.instagram.com/piso.05/reel/C40ttO1IbKI/" },
    { name: "Mava", src: "/media/logos/mava.svg", url: "https://www.instagram.com/piso.05/reel/DJMqeH2xft_/" },
    { name: "Arredo", src: "/media/logos/arredo.svg", url: "https://www.instagram.com/piso.05/reel/DIoeVmzR-kB/" },
];

return (
    <section className="w-full py-10 bg-neutral-100">
    <div className="w-full text-center">

        <h3 className="text-neutral-400 text-sm my-5 uppercase">Partnerships</h3>

        <Swiper
        modules={[Autoplay]}
        loop={true}

        autoplay={{
            delay: 2000,
            disableOnInteraction: false,
        }}

        speed={2000}
        grabCursor={true}

        centeredSlides={true}
        centeredSlidesBounds={true}

        spaceBetween={20}

        slidesPerView={2.5}
        breakpoints={{
            480: { slidesPerView: 3 },
            640: { slidesPerView: 4 },
            768: { slidesPerView: 5 },
            1024: { slidesPerView: 6 },
            1440: { slidesPerView: 7 },
        }}

        className="w-full"
        >
        {brands.map((brand) => (
            <SwiperSlide key={brand.name} className="flex justify-center items-center">
            <a
                href={brand.url}
                target="_blank"
                rel="noopener noreferrer"
                className="block"
            >
                <img
                src={brand.src}
                alt={brand.name}
                className="h-32 md:h-40 w-auto object-contain
                            opacity-70 hover:opacity-100
                            transition-all ease-in-out duration-700"
                />
            </a>
            </SwiperSlide>
        ))}
        </Swiper>

    </div>
    </section>
);
}
